export default "__VITE_ASSET__pUwjiDYD__"